import { FC } from 'react'
import useTranslation from 'next-translate/useTranslation'
import { Button, Modal } from 'rsuite'

import { Product } from '../../utils/types/Product'
import LowStockProductCard from '../Cart/LowStockProductCard'
import { CartProduct } from '../../utils/types/Order'
import { isCartProduct } from '../../utils/types/guards/Order'
import useUrls from '../../services/useUrls'

import buttonStyles from '../../styles/CustomButtons.module.less'
import styles from '../../styles/LowMovModalSingleProduct.module.less'

interface LowStockModalProps {
  lowStockProducts: (Product | CartProduct)[]
  isQuickReorder?: boolean
  redirect?: boolean
  setUnavailableProductsModalOpen: (isOpen: boolean) => void
  addProductsToCart: () => void
  isAddingProductsToCart: boolean
}

const LowStockModal: FC<LowStockModalProps> = (props) => {
  const {
    lowStockProducts,
    isAddingProductsToCart,
    redirect = true,
    isQuickReorder = false,
    addProductsToCart,
    setUnavailableProductsModalOpen,
  } = props

  const { pushT } = useUrls()
  const { t } = useTranslation('cart')

  const unavailableProductList = lowStockProducts.filter((product) => isCartProduct(product) || product['stock.stocklevel'] === 0)

  const getButtonText = () => {
    if (!unavailableProductList?.length) {
      return t(!isQuickReorder ? 'Continue to checkout' : 'products:Add to cart')
    }

    return isQuickReorder
      ? t('Continue to checkout without {{ productCount }} product', {
        productCount: unavailableProductList.length,
        count: unavailableProductList.length,
      })
      : t('Add to cart without {{ productCount }} product', {
        productCount: unavailableProductList.length,
        count: unavailableProductList.length,
      })
  }

  const handleCloseModal = () => {
    setUnavailableProductsModalOpen(false)
  }

  const goToCart = () => {
    if (redirect) pushT('/cart')
    handleCloseModal()
  }

  const onAddTocart = () => {
    addProductsToCart()
    goToCart()
  }

  return (
    <Modal
      enforceFocus={false}
      backdrop
      open
      onClose={handleCloseModal}
      size="md"
      className={styles['low-mov-modal']}
    >
      <Modal.Header>
        <h4>
          {t('Limited product availability')}
        </h4>
      </Modal.Header>
      <Modal.Body>
        <p>{t('Some items are unavailable or have limited stock Please review your order before proceeding')}</p>
        {lowStockProducts.map((product) => (
          <LowStockProductCard
            key={!isCartProduct(product) ? product.id : product['order.product.id']}
            product={product}
          />
        ))}
        <div className={styles.gradient} />
      </Modal.Body>
      <Modal.Footer>
        <Button
          appearance="primary"
          block
          onClick={onAddTocart}
          loading={isAddingProductsToCart}
          className={`margin-top-spacer-double margin-bottom-spacer ${buttonStyles['custom-button']} ${buttonStyles['button-primary']}`}
        >
          {getButtonText()}
        </Button>
        <Button
          appearance="ghost"
          block
          onClick={handleCloseModal}
        >
          {t('buyerProfile:Cancel')}
        </Button>
      </Modal.Footer>
    </Modal>
  )
}

export default LowStockModal
